import { render, staticRenderFns } from "./Jxxkz.vue?vue&type=template&id=6a5c871e&scoped=true&"
import script from "./Jxxkz.vue?vue&type=script&lang=js&"
export * from "./Jxxkz.vue?vue&type=script&lang=js&"
import style0 from "./Jxxkz.vue?vue&type=style&index=0&id=6a5c871e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5c871e",
  null
  
)

export default component.exports